import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (route.queryParamMap.get('token')) {
      return true;
    }

    if (!this.authService.isAuthenticated()) {
      this.authService.clearSession();
      return this.router.createUrlTree(['/login']);
    }

    if (!this.authService.isAllowedRole(this.authService.getRoleName())) {
      this.authService.clearSession();
      return this.router.createUrlTree(['/errorpath']);
    }

    return true;
  }
}
